import { render } from "./WorkspaceView.vue?vue&type=template&id=1998d936&scoped=true"
import script from "./WorkspaceView.vue?vue&type=script&lang=js"
export * from "./WorkspaceView.vue?vue&type=script&lang=js"

import "./WorkspaceView.vue?vue&type=style&index=0&id=1998d936&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1998d936"]])

export default __exports__